export default __webpack_public_path__ + "static/media/impressions.93381e71.svg";